import { render, staticRenderFns } from "./SortIcon.vue?vue&type=template&id=066b0dd8&scoped=true&"
import script from "./SortIcon.vue?vue&type=script&lang=js&"
export * from "./SortIcon.vue?vue&type=script&lang=js&"
import style0 from "./SortIcon.vue?vue&type=style&index=0&id=066b0dd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066b0dd8",
  null
  
)

component.options.__file = "SortIcon.vue"
export default component.exports